// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { event as ENUM_EVENT } from 'Enum';

type Props = {
  id: string | number,
};

/**
 * EventType
 *
 * @param {Props} props
 */
export const EventType = ({ id }: Props) => {
  const EVENT_TYPES_TRANSLATIONS = {
    [ENUM_EVENT.type.TYPE_SOLO_SHOW]: 'soloShow',
    [ENUM_EVENT.type.TYPE_ART_FAIR]: 'artFair',
    [ENUM_EVENT.type.TYPE_TALK]: 'talk',
    [ENUM_EVENT.type.TYPE_GROUP_SHOW]: 'groupShow',
    [ENUM_EVENT.type.TYPE_OTHER]: 'other',
  };

  return (
    <FormattedMessage id={`components.event.type.${EVENT_TYPES_TRANSLATIONS[id]}`}>
      {(type: string) => type}
    </FormattedMessage>
  );
};
